export const isAsyncAvailable = async () => false;

export const setItem = async (key, value) => {
  localStorage.setItem(key, value);
};

export const getItem = async (key) => {
  return localStorage.getItem(key);
};

export const removeItem = async (key) => {
  localStorage.removeItem(key);
};

export const getAllKeys = async () => {
  return Object.keys(localStorage);
};

export const multiGet = async (keys) => {
  return keys.map((key) => [key, localStorage.getItem(key)]);
};

export const clear = async () => {
  localStorage.clear();
};
